import { SIZES } from './getFormattedGoogleImages';

export function getImagesByQuality(images, quality) {
  const availableSizes = Object.keys(SIZES);

  return images.map(({ image, ...settings }) => {
    const imageData = availableSizes.reduce((result, currentQuality) => {
      if (currentQuality === quality || !result) {
        if (image[currentQuality]) {
          return image[currentQuality];
        }
      }

      return result;
    }, null);

    return {
      ...settings,
      image: imageData
    };
  });
}
